// One shared look for every plain numeric stat shown across the League tab:
// the standings table's Total/Wk/Dec%/Capt% columns, and the Hall of Fame's
// record values. Both used to pick their own size and weight (standings ran
// smaller and semibold, Hall of Fame larger and bold), which read as two
// different systems describing the same kind of thing. A shared constant
// instead of copy-pasted literals is what keeps them from drifting apart
// again the next time either page changes.
export const STAT_TEXT_STYLE = { fontSize: 14, fontWeight: 600, color: "var(--color-text-strong)" };
